const ITEMS = [
  "Ancient Wisdom",
  "Modern Magic",
  "Panchatantra Reimagined",
  "Early Readers · Ages 4–11",
  "Cinematic Digital Art",
  "Six Global Languages",
  "The 50-Book Roadmap",
];

export default function Marquee() {
  const Row = () => (
    <div className="flex shrink-0 items-center">
      {ITEMS.map((t) => (
        <span key={t} className="flex items-center">
          <span className="whitespace-nowrap px-8 font-serif text-lg italic tracking-wide text-gold/60 sm:text-xl">
            {t}
          </span>
          <svg viewBox="0 0 12 12" className="h-2.5 w-2.5 text-gold/35" aria-hidden="true">
            <path d="M6 0l1.6 4.4L12 6 7.6 7.6 6 12 4.4 7.6 0 6l4.4-1.6z" fill="currentColor" />
          </svg>
        </span>
      ))}
    </div>
  );

  return (
    <div
      className="overflow-hidden border-y border-gold/15 bg-emerald-deep py-6"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
